import React from 'react';
// import welcomeMessage from '../../../Assets/images/welcomeMessage.png';
import publish from '../../../Assets/icon/publish.png';
import { useNavigate } from 'react-router-dom';
import FreeTenderCards from './FreeTenderCards';
import WelcomeInDashboard from '../../Welcome/WelcomeInDashboard';
const NotPremiumUser = () => {
  const navigate = useNavigate();
  return (
    <div className="px-2 md:px-12 lg:px-16 container mx-auto">
      <WelcomeInDashboard />
      <div className="bg-white ">
        {/* Actions Section */}
        <section className="md:px-4 py-2 px-2 flex flex-col md:flex-row lg:flex-row gap-6 justify-evenly mb-8 md:text-xs 2xl:text-sm text-xs md:text-left text-start ">
          <div className="md:border-none border border-gray-200 rounded-md p-2 md:shadow-none shadow">
            <div className="flex gap-2 items-center md:justify-start justify-start ">
              <img src={publish} alt="" className="" />
              <h2 className="md:text-xl text-lg font-semibold text-gray-800 ">
                Publish Tender
              </h2>
            </div>
            <ol className="list-decimal list-inside text-gray-600 mt-4 space-y-2">
              <li>
                You can send a request to publish any tender on Tender Wise.
                <button
                  onClick={() => navigate('/tenderpublish')}
                  className="text-orange-500 font-semibold hover:underline ml-1"
                >
                  Publish Tender
                </button>
              </li>
              <li>We will verify your tender request before publish.</li>
              <li>
                Publish your tender with a very cost-effective way of 1000 taka
                only.
              </li>
              <li>
                The tender page needs to be an A4 sized PDF or image format with
                the company authorized seal.
              </li>
              <li>
                Upload your tender File as sample PDF Format.{' '}
                <span
                   className="text-orange-500 font-semibold hover:underline ml-1"
                  onClick={() => {
                    navigate('/tenderpublishDetails');
                  }}
                >
                  Read more
                </span>
              </li>
              <li>
                View your Tender publishing Request Status from View & Edit My
                Tender
              </li>
              <li>
                After verification use pay now option for complete your payment
              </li>
              <li>
                After published the Tender review it as user view from View All
                My Published Tender Tender publishing Request
              </li>
            </ol>
            <button
              onClick={() => {
                navigate('/tenderPublish');
                window.scrollTo(0, 0);
              }}
              className="mt-6 bg-orange-500 text-white px-6 py-2 rounded-md hover:bg-orange-600"
            >
              Request for Tender Posting
            </button>
          </div>
          <div className="md:mt-0 mt-4 md:block hidden">
            <div className="flex gap-2 items-center md:justify-start justify-center ">
              <img src={publish} alt="" />
              <h2 className="md:text-xl text-lg  font-semibold text-gray-800">
                Become our Premium Member
              </h2>
            </div>
            <ol className="list-decimal list-inside text-gray-600 mt-4 space-y-2">
              <li>
                Search tenders by category, department, source, and location
              </li>
              <li>Find private, government, and international tenders.</li>
              <li>
                Filter tenders by publication and submission date and advanced
                search.
              </li>
              <li>View live and expired tenders separately.</li>
              <li>Whitelist tenders and save them to your favorite list.</li>
              <li>Share full tender details with anyone.</li>
              <li>Download tenders in PDF format for future reference.</li>
              <li>
                Enjoy all these exclusive benefits as a Premium
                Member on TenderWise!
              </li>
            </ol>
            <button
              onClick={() => {
                navigate('/pricingPackages');
                window.scrollTo(0, 0);
              }}
              className="mt-6 bg-orange-200 text-orange-400 px-6 py-2 rounded-md hover:bg-orange-200"
            >
              Buy Subscription --&gt;
            </button>
          </div>
        </section>

        {/* Free tender Section */}
        {/* <section className="mb-4">
          <img src={welcomeMessage} alt="" />
        </section> */}

        <FreeTenderCards />
      </div>
    </div>
  );
};

export default NotPremiumUser;
